<template>
  <div v-if="visibility">
   
    <ValidationObserver v-slot="{ validate }" ref="observer">
      <template v-for="field in fields">
        <div :key="field._id">
          <b-form-group v-if="isTextInput(field.dataType)">
            <ValidationProvider
              :rules="field.isRequired ? 'required' : ''"
              v-slot="{ errors }"
              :name="field.fieldName"
            >
              <CustInput
                :inputType="getFieldInputType(field.dataType)"
                :inputId="field.fieldName"
                v-model="formData[field.fieldName]"
                :lableText="`${field.fieldName}${field.isRequired ? ' *' : ''}`"
                class="w-100"
              ></CustInput>
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>

          <b-form-group v-else-if="field.dataType === 'Date'">
            <ValidationProvider
              :rules="field.isRequired ? 'required' : ''"
              v-slot="{ errors }"
              :name="field.fieldName"
            >
              <CustInput
                inputType="date"
                :inputId="field.fieldName"
                v-model="formData[field.fieldName]"
                :lableText="`${field.fieldName}${field.isRequired ? ' *' : ''}`"
              >
              </CustInput>
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>

          <b-form-group v-else-if="field.dataType === 'Boolean'">
            <ValidationProvider
              :rules="field.isRequired ? 'required' : ''"
              v-slot="{ errors }"
              :name="field.fieldName"
            >
              <v-switch
                v-model="formData[field.fieldName]"
                color="indigo"
                :label="`Is ${field.fieldName}${field.isRequired ? ' *' : ''}?`"
              ></v-switch>
              <span class="validate-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </b-form-group>
        </div>
      </template>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CustInput from "@/components/Common/CustomInput";

export default {
  props: {
    fields: {
      type: Array,
      required: true,
    },
    visibility: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  methods: {
    isTextInput(type) {
      return type === "String" || type === "Integer" || type === "Decimal";
    },
    getFieldInputType(type) {
      return type === "String"
        ? "text"
        : type === "Integer"
        ? "number"
        : "text";
    },
    async validateForm() {
      const isValid = await this.$refs.observer.validate();
      return isValid;
    },
    setData(data) {
      this.fields.forEach((field) => {
        this.$set(this.formData, field.fieldName, "");
      });
      for (const key of Object.keys(data)) {
        this.formData[key] = data[key];
      }
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    CustInput,
  },

  mounted() {
    this.fields.forEach((field) => {
      this.$set(this.formData, field.fieldName, "");
    });
  },
  watch: {
    formData: {
      deep: true,
      handler(newVal) {
        this.$emit("update:formData", newVal);
      },
    },
  },
};
</script>

<style scoped>
.validate-error {
  color: red;
}
</style>
